<ion-content class="app" slot="fixed">
  <div class="app__content onboarding">
    <div class="onboarding__content">
      <app-state-notice
        [iconPath]="'/assets/illustrations/feedback_completed.svg'"
        [title]="'onboarding.success.title' | translate"
        [desc]="'onboarding.success.desc' | translate"
      >
      </app-state-notice>
      <button class="onboarding__content__button" routerLink="/feed">
        <span> {{ 'onboarding.success.button' | translate }} </span>
        <span
          aria-hidden="true"
          class="icon"
          [inlineSVG]="'/assets/icons/card/arrow-right.svg'"
        ></span>
      </button>
    </div>
  </div>
</ion-content>
